import { LuCheckCircle } from 'react-icons/lu'
import { LINKS } from 'routes/constants'
import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions'
import { landingSolutionsData } from './landingSolutionsData'
import { LandingSolutionCard } from './LandingSolutionsCard'
import NavLink from 'ui-kit/actions/link/NavLink'
import AIIcon from './icon-ai.svg'
import classes from './LandingSolutions.module.scss'

export const LandingSolutions = () => {
  return (
    <Block as={'section'} divider={'mobile'} className={classes.section}>
      <Heading as={'h2'} size={'xl'} balance center className={classes.title}>
        Build any use case
      </Heading>
      <ul className={classes.list}>
        {landingSolutionsData.map((item, index) => (
          <LandingSolutionCard key={index} {...item} />
        ))}
      </ul>
      <div className={classes.aiBlock}>
        <img src={AIIcon.src} alt='AI' className={classes.aiBlock_image} />
        <div className={classes.aiBlock_content}>
          <div className={classes.aiBlock_description}>
            <NavLink
              href={LINKS.SOLUTIONS.AI_AGENTS}
              className={classes.aiBlock_link}
            >
              <Heading as={'h3'} size={'lg'} balance>
                AI Membrane: Build fully integrated AI agents
              </Heading>
            </NavLink>
            <ul className={classes.aiBlock_list}>
              <li className={classes.aiBlock_item}>
                <LuCheckCircle className={classes.aiBlock_icon} />
                <Text as={'span'}>Knowledge Import</Text>
              </li>
              <li className={classes.aiBlock_item}>
                <LuCheckCircle className={classes.aiBlock_icon} />
                <Text as={'span'}>Dynamic Tool Usage</Text>
              </li>
              <li className={classes.aiBlock_item}>
                <LuCheckCircle className={classes.aiBlock_icon} />
                <Text as={'span'}>AI Workflow Building</Text>
              </li>
            </ul>
          </div>
          <Link
            type={'secondary'}
            href={LINKS.SOLUTIONS.AI_AGENTS}
            target={'_blank'}
            className={classes.aiBlock_button}
          >
            Learn more
          </Link>
        </div>
      </div>
    </Block>
  )
}
